var MDB = window.MDB || {};;
(function ($, global) {
    MDB.WidgetEditor = MDB.WidgetEditor || {};
    var paletteEditor = MDB.WidgetEditor.PaletteEditor = {};

    var model, form;
    var paletteTileSize = 25;
    var defaultColor = '#dd8951'; // Kendo UI Chart orange.

    $.extend(MDB.WidgetEditor.PaletteEditor, {
        init: function(widgetModel, paletteForm) {
            model = widgetModel;
            form = paletteForm; 
            if (!form) {
                form = $('.weditor-colors > form');
            } 
        },
        defaultColor: defaultColor,
        createPaletteConf: function () {
        	if (!form) {
                form = $('.weditor-colors > form');
            } 
            var params = form.serializeArray()
                .filter(function (value, index, array) { // Drops the extra field that the Html helper adds to a checked checkbox.
                    if (index === 0) {
                        return true;
                    } else {
                        return array[index - 1].name !== array[index].name;
                    }
                })
                .map(function (param) {
                    return param.value;
                });

            return {
                NumberOfColors: parseInt(params[0]),
                PaletteType: params[1],
                BasePaletteType: params[1].split('-')[0],
                HSVSaturation: parseFloat(params[2]),
                HSVValue: parseFloat(params[3]),
                Linear: params[4] === 'true'
            };
        },
        getKendoPalettes: function () {
            var source = kendo.dataviz.ui.themes;
            return _.map(_.keys(source), function(key) {
                return {name: 'Kendo: ' + key, colors: source[key].chart.seriesColors} 
            });
        },
        generatePaletteColors: function (paletteConf) {
        	if (!form) {
                form = $('.weditor-colors > form');
            } 
            var colors = [];
            
            var kendoPalette = _.find(this.getKendoPalettes(), function (kConf) {
                return kConf.name === paletteConf.PaletteType; 
            });
            if (kendoPalette) {
                colors = _.take(kendoPalette.colors, paletteConf.NumberOfColors);
            }
            
            switch (paletteConf.BasePaletteType) {
            case 'tol':
                colors = palette(paletteConf.PaletteType, paletteConf.NumberOfColors);
                break;
            case 'rainbow':
                colors = palette(paletteConf.PaletteType, paletteConf.NumberOfColors, 0, paletteConf.HSVSaturation, paletteConf.HSVValue);
                break;
            case 'grayscale':
                var paletteFunc = function (x) {
                    return paletteConf.Linear ? palette.linearRgbColor(x, x, x) : palette.rgbColor(x, x, x);
                };
                colors = palette.generate(paletteFunc, paletteConf.NumberOfColors);
                break;
            case 'random':
                var hexChars = '0123456789abcdef'.split('');

                for (var i = 0; i < paletteConf.NumberOfColors; i++) {
                    var colorStr = '#';
                    for (var char = 0; char < 6; char++) {
                        colorStr += hexChars[Math.floor(Math.random() * 16)];
                    }
                    colors.push(colorStr);
                }
                break;
            }

            //In case the requested amount of colors isn't present in the palette
            //Copy the palette from the start until we reach the appropriate amount
            if (paletteConf.NumberOfColors > colors.length){
                _.forEach(_.range(colors.length, paletteConf.NumberOfColors), function (n, iteration) {
                    colors.push(colors[iteration])
                });
            }

            colors = colors.map(function (color) { // Normalize color format
                return color[0] !== '#' ? '#' + color : color;
            });
            return colors;
        },
        renderActivePalette: function (isSingleColor) {
            // color pickers
            var container = $('#active-palette').parent();
            var newPalette = $('<div id="active-palette"></div>');
            var colors = model.getColors();
            newPalette.kendoColorPalette({
                palette: colors.map(function (color) {
                    return color.ColorValue 
                }),
                tileSize: paletteTileSize
            }).off(); // switch off the default palette events;

            var tiles = newPalette.find('td');
            tiles.each(function (index, tile) {
                tile = $(tile);
                tile.data('iid', colors[index]._id);
                var colorpicker = tile
                    .kendoColorPicker({
                        change: function (eventInner) {
                            model.updateColor(this.element.data('iid'), eventInner.value);
                            paletteEditor.updatePaletteUI();
                        },
                        value: tile.attr('aria-label')
                    })
                    .data('kendoColorPicker');

                colorpicker.wrapper.find('.k-picker-wrap, .k-selected-color')
                    .css({ 'width': paletteTileSize + 'px', 'height': paletteTileSize + 'px' });
            });

            container.empty().append(newPalette);

            if (isSingleColor) {
                tiles.last().next().find('.k-selected-color').click();
            }
        },
        renderRecentPalettes: function () {
            $('.saved-palette').each(function (index, element) {
                $(element).kendoColorPalette({
                    palette: $(element).data('colors'),
                    tileSize: paletteTileSize
                }).off(); // switch off the default palette events;
            });
        },
        previewPalette: function () {
            var container = $('#preview-palette').empty();
            if ($('#Metadata_NumberOfColors').val() > 0) {
                var paletteConf = paletteEditor.createPaletteConf();
                // console.log(paletteConf);
                
                var colors = (paletteConf.NumberOfColors === 1) ? [defaultColor] : paletteEditor.generatePaletteColors(paletteConf);

                container.kendoColorPalette({
                    palette: colors,
                    tileSize: paletteTileSize
                }).off();
            }
        },
        updatePaletteCheckmarks: function () {
            $('.saved-palettes').find('.fa-check').each(function (index, element) {
                element = $(element);
                if (element.prev().prop('checked')) {
                    element.show();
                } else {
                    element.hide();
                }
            });
        },
        updatePaletteUI: function (clearCheckmarks) {
            // Uncheck any recent palettes
            if (clearCheckmarks) {
                $('.saved-palettes').find('input[type="radio"]').prop('checked', false);
            }
            paletteEditor.updatePaletteCheckmarks();

            // Update the palette editor buttons.
            if (model.getColors().length === 0) {
                $('.weditor-colors').find('.btn-remove, .btn-delete-all, .btn-shuffle').addClass('disabled');
                $('#color-editor-help').text(MDB.loadResourceString('Widget_Edit_Section_Palettes_Active_Empty_Help'));
            } else if (model.getColors().length === 1) {
                $('.weditor-colors').find('.btn-remove, .btn-shuffle').addClass('disabled');
                $('.weditor-colors').find('.btn-delete-all').removeClass('disabled');
                $('#color-editor-help').text(MDB.loadResourceString('Widget_Edit_Section_Palettes_Active_Help'));
            } else {
                $('.weditor-colors').find('.btn-remove, .btn-delete-all, .btn-shuffle').removeClass('disabled');
                $('#color-editor-help').text(MDB.loadResourceString('Widget_Edit_Section_Palettes_Active_Help'));
            }
        }
    });
})(jQuery, window);